/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Welcome_BackInputs */



/**
* | output |
* | --- |
* | "Welcome back! Sign in to your account." |
*
* @param {Login_Welcome_BackInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_welcome_back = /** @type {((inputs?: Login_Welcome_BackInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Welcome_BackInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bon retour ! Connectez-vous à votre compte.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Bienvenido de nuevo! Inicie sesión en su cuenta.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Bem-vindo de volta! Entre na sua conta.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bentornato! Accedi al tuo account.")
	return /** @type {LocalizedString} */ ("Welcome back! Sign in to your account.")
});